<template>
    <div class="blank-layout">
        <!-- <slot></slot> -->
        <router-view></router-view>
    </div>
</template>

<script>
    // import '@/utils/bg.js';
    export default {
        
    }
</script>

<style lang="less" scoped>
    .blank-layout {
        display: block;
        position: relative;
        width: 100%;
        height: 100%; 
    }
</style>